import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { AnimatePresence } from "framer-motion"
import Measure from 'react-measure'
import _ from 'lodash'

import { ListTile, Button, Animation } from 'components'
import { DeleteDialogue, PageSelector } from 'features'
import { sectionContext } from 'context'
import { Page } from 'schema'
import ContextMenu from '../ContextMenu'
import {FaEdit, FaArchive, FaTrashAlt, FaArrowUp, FaArrowDown, FaExchangeAlt, FaTasks, FaAngleLeft, FaEye, FaEyeSlash} from 'react-icons/fa';

import * as actionCreators from 'store/actions'

const Line = styled.hr`
    border-color: var(--secondary-accent2-color);
`;

const Title = styled.div`
    grid-template-columns: 2rem auto 2rem;
    display: grid;
    justify-items: center;
    align-items: center;
    margin-bottom: 0.3rem;
    font-weight: bolder;
    font-size: 0.9rem;
`


class SectionOptions extends Component {
    constructor(props) {
        super(props);
        this.section = this.props.section
        this.state = {
            content: null,
            boundingRect: null,
        }

        this.buttonStyle = {
            backgroundColor:'var(--secondary-color)',
            margin:'0',
            boxShadowColor: 'transparent',
            padding: '0.5rem'
        }
        console.log('[SectionOptions]', this.props.section)
    }

    updateSectionOrder = direction => {
        let page = this.props.data['pages'][this.props.section['pageID']]
        let sections = Object.values(page['sections'])
        const currentIndex = sections.indexOf(this.props.section['sectionID'])
        const newIndex = direction === 'up' &  currentIndex !== 0 ? currentIndex - 1 
                        : direction === 'down' & currentIndex !== sections.length ? currentIndex + 1
                        : currentIndex
        let active = 0
        sections.map(sectionID => {
            this.props.data['sections'][sectionID]['status'] === sectionContext.STATUS.ACTIVE && active++
        })
        const upperBound = !this.props.user['show_archived'] ? sections.length - 1 : active - 1
        console.log({new: newIndex, current: currentIndex, upper: upperBound})
        if(newIndex !== currentIndex & newIndex !== 0 & newIndex <= upperBound){
            sections[currentIndex] = sections[newIndex]
            sections[newIndex] = this.props.section['sectionID']
            page['sections'] = sections
            this.props.updatePage(page, this.props.data, this.props.uid)
            this.props.closeHandler()
        }
    }

    archiveSectionHandler = () => {
        let updatedSection = (({ details, section_items, ...o }) => o)(this.section)
        updatedSection['status'] = updatedSection['status'] === sectionContext.STATUS.ACTIVE ? sectionContext.STATUS.ARCHIVE : sectionContext.STATUS.ACTIVE
        this.props.updateSection(updatedSection, this.props.data, this.props.uid, this.props.sessionId)
        this.props.closeHandler()
    }

    toggleEditHandler = () => {
        this.props.setInput(`${this.section.sectionID}_SectionBlock`)
        this.props.closeHandler()
    }

    toggleChildrenHandler = () => {
        let updatedSection = this.props.section
        updatedSection['show_children'] = !updatedSection['show_children']
        this.props.updateSection(updatedSection, this.props.data, this.props.uid, this.props.sessionId)
        this.props.closeHandler()
    }

    toggleItemsHandler = () => {
        let updatedSection = this.props.section
        updatedSection['items_visibility'] = !updatedSection['items_visibility']
        this.props.updateSection(updatedSection, this.props.data, this.props.uid, this.props.sessionId)
        this.props.closeHandler()
    }

    shiftSectionHandler = (pageID) => {
        // console.log('[SectionOptions] shiftSection', {current: this.props.section['pageID'], target: pageID})
        this.props.section['pageID'] !== pageID &&this.props.shiftSection(this.props.data, this.props.section, pageID, this.props.uid, this.props.sessionId)
    }

    _getPage = () => {
        let page_details = this.props.data['pages'][this.props.activePageID]
        page_details['pageID'] = this.props.activePageID
        const page = new Page(page_details)
        return page
    }

    deleteHandler = () => {
        this.props.deleteSection(this.props.section, this.props.data, this.props.data['pages'][this.props.section['pageID']])
        this.props.closeHandler()
    }

    render(){
        let content = null
        switch (this.state.content){
            case 'archive':
                content = 
                <AnimatePresence key='archive'>
                    <div></div>
                    <Animation key='archive' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <DeleteDialogue submitText={this.section['status'] === sectionContext.STATUS.ACTIVE ? 'Archive' : 'Unarchive'} 
                            onDelete={this.archiveSectionHandler}
                            closeHandler={() => {this.setState({content: 'main'})}}
                            />
                    </Animation>
                </AnimatePresence>
                break
            
            case 'delete':
                content = 
                <AnimatePresence key='delete'>
                    <div></div>
                    <Animation key='delete' animation='slideLeft' boundingRect={this.state.boundingRect}>
                    <DeleteDialogue 
                            onDelete={this.deleteHandler}
                            closeHandler={() => {this.setState({content: 'main'})}}/>
                    </Animation>
                </AnimatePresence>
                break
            
            case 'shift':
                content = 
                <AnimatePresence key='shift'>
                    <Title>
                        <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.buttonStyle}/>
                        <div>Shift section</div>
                    </Title>
                    <Animation key='main' animation='slideLeft' boundingRect={this.state.boundingRect}>
                        <PageSelector pageID={this.props.section['pageID']}
                            onSelect={this.shiftSectionHandler} onClose={() => {this.setState({content: 'main'})}}/>
                    </Animation>
                </AnimatePresence>
                break

            case 'main':
                content = 
                <AnimatePresence key='main'>
                    <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                        <ListTile text='Edit' icon={<FaEdit/>} onSelect={this.toggleEditHandler}/>
                        <ListTile text={`${this.section['items_visibility'] ? 'Hide' : 'Show'} items`} icon={this.section['items_visibility'] ? <FaEyeSlash/>: <FaEye/>} onSelect={this.toggleItemsHandler}/>
                        <ListTile text={`${this.section['show_children'] ? 'Hide' : 'Show'} sub-items`} icon={<FaTasks/>} onSelect={this.toggleChildrenHandler}/>
                        <Line size='1'/>
                        <ListTile text='Change page' icon={<FaExchangeAlt/>} onSelect={() => {this.setState({content: 'shift'})}}/>
                        <ListTile text='Move up' icon={<FaArrowUp/>} onSelect={() => {this.updateSectionOrder('up')}}/>
                        <ListTile text='Move down' icon={<FaArrowDown/>} onSelect={() => {this.updateSectionOrder('down')}}/>
                        <Line size='1'/>
                        <ListTile text={this.section['status'] === sectionContext.STATUS.ACTIVE ? 'Archive' : 'Unarchive'} icon={<FaArchive/>} onSelect={() => {this.setState({content: 'archive'})}}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content: 'delete'})}}/>
                    </Animation>
                </AnimatePresence>
                break
            default:
                content = 
                <AnimatePresence key='default'> 
                    <Animation key='default' boundingRect={this.state.boundingRect}>
                        <ListTile text='Edit' icon={<FaEdit/>} onSelect={this.toggleEditHandler}/>
                        <ListTile text={`${this.section['items_visibility'] ? 'Hide' : 'Show'} items`} icon={this.section['items_visibility'] ? <FaEyeSlash/>: <FaEye/>} onSelect={this.toggleItemsHandler}/>
                        <ListTile text={`${this.section['show_children'] ? 'Hide' : 'Show'} sub-items`} icon={<FaTasks/>} onSelect={this.toggleChildrenHandler}/>
                        <Line size='1'/>
                        <ListTile text='Change page' icon={<FaExchangeAlt/>} onSelect={() => {this.setState({content: 'shift'})}}/>
                        <ListTile text='Move up' icon={<FaArrowUp/>} onSelect={() => {this.updateSectionOrder('up')}}/>
                        <ListTile text='Move down' icon={<FaArrowDown/>} onSelect={() => {this.updateSectionOrder('down')}}/>
                        <Line size='1'/>
                        <ListTile text={this.section['status'] === sectionContext.STATUS.ACTIVE ? 'Archive' : 'Unarchive'} icon={<FaArchive/>} onSelect={() => {this.setState({content: 'archive'})}}/>
                        <ListTile text='Delete' icon={<FaTrashAlt/>} onSelect={() => {this.setState({content: 'delete'})}}/>
                    </Animation>
                </AnimatePresence>
        }
        

        return(
            <ContextMenu>
                <Measure
                    bounds
                    onResize={contentRect => {
                        this.setState({ boundingRect: contentRect.bounds })
                    }}
                >
                    {({ measureRef }) => (
                        <div ref={measureRef}>{content}</div>
                    )}
                </Measure>
            </ContextMenu>
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        user: state.auth.user,
        sessionId: state.content.sessionId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateSection: (section, data, userId, sessionId) => dispatch(actionCreators.updateSection(section, data, userId, sessionId)),
        deleteSection: (section, data, page) => dispatch(actionCreators.deleteSection(section, data, page)),
        updatePage: (page, data, userId, sessionId) => dispatch(actionCreators.updatePage(page, data, userId, sessionId)),
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID)),
        shiftSection: (data, section, pageID, userId, sessionId) => dispatch(actionCreators.shiftSection(data, section, pageID, userId, sessionId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionOptions);